import type { Namespace } from './types';

/** 国家码词表 —— 键表真源在 `shared/domain/countries.ts`，两边由 `countries.test.ts` 双向对齐守着。 */
export const zh: Namespace = {
  countries: {
    format: '{{name}}（{{code}}）',
    CN: '中国',
    HK: '中国香港',
    MO: '中国澳门',
    TW: '中国台湾',
    JP: '日本',
    KR: '韩国',
    SG: '新加坡',
    MY: '马来西亚',
    TH: '泰国',
    VN: '越南',
    PH: '菲律宾',
    ID: '印度尼西亚',
    IN: '印度',
    PK: '巴基斯坦',
    BD: '孟加拉国',
    RU: '俄罗斯',
    UA: '乌克兰',
    BY: '白俄罗斯',
    KZ: '哈萨克斯坦',
    GB: '英国',
    IE: '爱尔兰',
    DE: '德国',
    FR: '法国',
    ES: '西班牙',
    IT: '意大利',
    NL: '荷兰',
    BE: '比利时',
    LU: '卢森堡',
    AT: '奥地利',
    CH: '瑞士',
    PL: '波兰',
    CZ: '捷克',
    SK: '斯洛伐克',
    HU: '匈牙利',
    RO: '罗马尼亚',
    BG: '保加利亚',
    GR: '希腊',
    PT: '葡萄牙',
    SE: '瑞典',
    NO: '挪威',
    DK: '丹麦',
    FI: '芬兰',
    US: '美国',
    CA: '加拿大',
    MX: '墨西哥',
    BR: '巴西',
    CL: '智利',
    CO: '哥伦比亚',
    PE: '秘鲁',
    AR: '阿根廷',
    IL: '以色列',
    SA: '沙特阿拉伯',
    AE: '阿拉伯联合酋长国',
    QA: '卡塔尔',
    KW: '科威特',
    BH: '巴林',
    OM: '阿曼',
    EG: '埃及',
    ZA: '南非',
    NG: '尼日利亚',
    TR: '土耳其',
    AU: '澳大利亚',
    NZ: '新西兰',
  },
};

export const en: Namespace = {
  countries: {
    format: '{{name}} ({{code}})',
    CN: 'China',
    HK: 'Hong Kong',
    MO: 'Macao',
    TW: 'Taiwan',
    JP: 'Japan',
    KR: 'South Korea',
    SG: 'Singapore',
    MY: 'Malaysia',
    TH: 'Thailand',
    VN: 'Vietnam',
    PH: 'Philippines',
    ID: 'Indonesia',
    IN: 'India',
    PK: 'Pakistan',
    BD: 'Bangladesh',
    RU: 'Russia',
    UA: 'Ukraine',
    BY: 'Belarus',
    KZ: 'Kazakhstan',
    GB: 'United Kingdom',
    IE: 'Ireland',
    DE: 'Germany',
    FR: 'France',
    ES: 'Spain',
    IT: 'Italy',
    NL: 'Netherlands',
    BE: 'Belgium',
    LU: 'Luxembourg',
    AT: 'Austria',
    CH: 'Switzerland',
    PL: 'Poland',
    CZ: 'Czechia',
    SK: 'Slovakia',
    HU: 'Hungary',
    RO: 'Romania',
    BG: 'Bulgaria',
    GR: 'Greece',
    PT: 'Portugal',
    SE: 'Sweden',
    NO: 'Norway',
    DK: 'Denmark',
    FI: 'Finland',
    US: 'United States',
    CA: 'Canada',
    MX: 'Mexico',
    BR: 'Brazil',
    CL: 'Chile',
    CO: 'Colombia',
    PE: 'Peru',
    AR: 'Argentina',
    IL: 'Israel',
    SA: 'Saudi Arabia',
    AE: 'United Arab Emirates',
    QA: 'Qatar',
    KW: 'Kuwait',
    BH: 'Bahrain',
    OM: 'Oman',
    EG: 'Egypt',
    ZA: 'South Africa',
    NG: 'Nigeria',
    TR: 'Turkey',
    AU: 'Australia',
    NZ: 'New Zealand',
  },
};
